module.exports = __webpack_public_path__ + "static/media/country_bs.1d6e80ec.webp";